import React, { Component } from 'react';
import { connect } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { Link } from 'react-router-dom'
import Button from '@material-ui/core/Button';
import axios from '../../http-config';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

class ThankPage extends Component {
    render() {
        return (
            <div>
                <div className="dashboard_right_content" style={{  borderRadius: "0px" }}>
            
                    <div className="create_ulb_content_outer">
                        <div className=" " style={{display:'flex', flexDirection: 'column'}}>
                            <div className="">
                          <CheckCircleIcon style={{color:'#3dab35', height:'400px', width:'400px'}}/>

                            </div>
                        <div style={{display:'flex', flexDirection: 'column', marginBottom:'15px'}}>
                            <h3>Your request is submitted Successfully.</h3>
                            {/* <h2>Thankyou !!</h2> */}
                          
                        </div>
                        <p> Kindly note your request Id: {!!this.props.citizenData&&this.props.citizenData.Req_id}  </p>
                        </div>
                    </div>

                    <div style={{float:'right'}}>
            <Link to="/" style={{textDecoration:"none", color:"#3dab35"}}> 
                <Button className="login_submit" variant="outlined" color="primary" style={{
                            background:'none',
                            color:'#3dab35',
                            border:" 1px solid rgba(61, 171, 53, 0.5)",
                            }} >Close</Button>
                </Link>
            </div>
        
                    </div>
                     </div>
        )
    }
}

// export default ThankPage;
const mapStateToProps = state => {
    return {
        // Dataerror: state.propertyListing.error
        citizenData:state.propertyListing.citizenRes[0]
    }
}
const mapDispatchToProps = dispatch => {
    return {
        // onCitizenPropertyAdd: (payload, props)=>dispatch(actionsCreators.citizenPropertyAdd(payload, props))
        
    }
}
export default  connect(mapStateToProps, mapDispatchToProps)(ThankPage);


